import { useEffect, useRef } from 'react';
import '../styles/LandingPage/Cursor.css';

export default function useCursor() {
  const curRef  = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const cur  = curRef.current;
    const ring = ringRef.current;
    if (!cur || !ring) return;

    let mx = 0, my = 0, rx = 0, ry = 0;
    let rafId;

    const onMove = (e) => {
      mx = e.clientX; my = e.clientY;
      cur.style.left = mx + 'px'; cur.style.top = my + 'px';
    };

    const loop = () => {
      rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      rafId = requestAnimationFrame(loop);
    };
    loop();

    const enterLink = () => {
      ring.style.width = '50px'; ring.style.height = '50px';
      ring.style.borderColor = 'rgba(15,158,138,0.5)';
    };
    const leaveLink = () => {
      ring.style.width = '34px'; ring.style.height = '34px';
      ring.style.borderColor = 'rgba(15,158,138,0.35)';
    };

    document.addEventListener('mousemove', onMove);
    document.querySelectorAll('a, button').forEach(el => {
      el.addEventListener('mouseenter', enterLink);
      el.addEventListener('mouseleave', leaveLink);
    });

    return () => {
      document.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <>
      <div className="cursor"  ref={curRef}  />
      <div className="cursor-ring" ref={ringRef} />
    </>
  );
}